module.exports = __webpack_public_path__ + "img/codCuentas.28190b49.svg";